import React, { Component } from 'react';
import AppContentComponent from '../../templates/content'
import AppStatisticsCompareComponent from './components/compare'
import { Route } from 'react-router-dom'

class AppStatisticsComponent extends Component {

	render() {
		return (
			<AppContentComponent>
				<Route exact path="/app/stats/:type" component={AppStatisticsCompareComponent} />
			</AppContentComponent>
		)
	}
}

export default AppStatisticsComponent;


// WEBPACK FOOTER //
// ./src/application/components/statistics/index.js